import { render, staticRenderFns } from "./BsiFooter.vue?vue&type=template&id=df6bd256&scoped=true"
import script from "./BsiFooter.vue?vue&type=script&lang=js"
export * from "./BsiFooter.vue?vue&type=script&lang=js"
import style0 from "./BsiFooter.vue?vue&type=style&index=0&id=df6bd256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6bd256",
  null
  
)

export default component.exports